import React, { useEffect  }  from 'react' 
import  {LinkContainer}  from 'react-router-bootstrap'

import {Table, Button, Container } from 'react-bootstrap'

import { useDispatch, useSelector } from 'react-redux'

import Message from '../../Message/Message' 
import Loader from '../../Loader/Loader' 

import { listStagiaires}  from '../../../actions/stagiaireActions'

import {  deleteStagiaires }  from '../../../actions/stagiaireActions'

import './list.css'





const StagiaireList = ({ history }) => {

    const dispatch = useDispatch()

    const stagiaireList = useSelector(state => state.stagiaireList)
    const { loading, error, stagiaires } = stagiaireList

    const stagiaireRegister = useSelector(state => state.stagiaireRegister)
    const { stagiaireInfo } = stagiaireRegister

    const stagiaireDelete = useSelector(state => state.stagiaireDelete)
    const { success: successDelete } = stagiaireDelete

   

    useEffect(() => {
     (stagiaireInfo) && dispatch(listStagiaires())
  
    }, [dispatch, successDelete, stagiaireInfo])

    const deleteHandler = (id) => {
        if (window.confirm('Are you sure')) {
            dispatch(deleteStagiaires(id))
        }
    }


//    const goBack = () => {
  //      history.goBack(); // This function navigates back to the previous page
    //  };



    return (
        <div className="main"  fluid >
            <br />
            <LinkContainer style={{ float: 'right',  backgroundColor: 'red'  }}   to="/registerstagiaire">
                <Button style={{  backgroundColor: 'red'  }} className="mr-3 mb-3"> ajouter un stagiaire </Button>
            </LinkContainer>

            
            <br />
            <br />
            <Container>
                {loading ? <Loader />
                    : error ? <Message variant='danger'>{error}</Message>
                        : (
                            <div class="table-responsive text-nowrap">
                           <Table    responsive    class="table table-striped" >
                                <thead>
                                    <tr>
                                         <th>Nom et prénom</th>
                                         <th> Email </th>
                                         <th> Numéro de téléphone </th>
                                         <th>Formation </th>
                                         <th> Condition </th>

                                        
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        stagiaires.map(stagiaire => (
                                            < tr key={stagiaire._id}>
                                                <td>{stagiaire.name}</td>
                                                <td>{stagiaire.email}</td>
                                                <td>{stagiaire.phonenumber}</td>
                                                <td>{stagiaire.formation}</td>
                                                <td>{stagiaire.condition}</td>
                                             
                                                <td>
                                                                                                       
                                                    <Button
                                                        variant="danger"
                                                        className="btn-sm mr-2"
                                                        onClick={() => deleteHandler(stagiaire._id)}
                                                    >
                                                        <i className="fas fa-trash-alt"></i>
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </Table>
                        </div>
                        )
                }
            </Container>
        </div>
    )
}

export default StagiaireList
